import { FC } from "react";

export const AffiliateIcon: FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6001 14.3967C1.6001 13.86 1.86916 13.359 2.31661 13.0627L15.1166 4.58513C15.6522 4.23041 16.348 4.23041 16.8836 4.58513L29.6836 13.0627C30.131 13.359 30.4001 13.86 30.4001 14.3967V28C30.4001 28.8836 29.6838 29.6 28.8001 29.6H3.2001C2.31644 29.6 1.6001 28.8836 1.6001 28V14.3967Z"
        fill="url(#paint0_linear_1609_7317)"
      />
      <path
        d="M28.8001 28.8V29.6H3.2001V28.8H28.8001ZM29.6001 28V14.3969C29.6001 14.1285 29.4652 13.8778 29.2415 13.7297L16.4415 5.25232C16.2073 5.09729 15.9121 5.07755 15.6626 5.19373L15.5587 5.25232L2.75869 13.7297C2.53497 13.8778 2.4001 14.1285 2.4001 14.3969V28C2.4001 28.4418 2.75827 28.8 3.2001 28.8V29.6L3.03682 29.5914C2.28357 29.515 1.68506 28.9165 1.60869 28.1633L1.6001 28V14.3969C1.6001 13.8937 1.83627 13.4215 2.23447 13.1203L2.3165 13.0625L15.1165 4.58513C15.6521 4.23041 16.3481 4.23041 16.8837 4.58513L29.6837 13.0625C30.1311 13.3588 30.4001 13.8602 30.4001 14.3969V28L30.3915 28.1633C30.3151 28.9165 29.7166 29.515 28.9634 29.5914L28.8001 29.6V28.8C29.2419 28.8 29.6001 28.4418 29.6001 28Z"
        fill="url(#paint1_linear_1609_7317)"
      />
      <path
        d="M5.6001 4.7999C5.6001 3.47442 6.67461 2.3999 8.0001 2.3999H20.1374C20.5617 2.3999 20.9687 2.56847 21.2687 2.86853L25.9315 7.53127C26.2315 7.83133 26.4001 8.2383 26.4001 8.66264V17.2121C26.4001 17.7088 26.1694 18.1774 25.7756 18.4803L16.9998 25.2309C16.4135 25.6819 15.5944 25.6722 15.0189 25.2074L6.19476 18.0802C5.81868 17.7764 5.6001 17.3189 5.6001 16.8355V4.7999Z"
        fill="url(#paint2_linear_1609_7317)"
      />
      <path
        d="M5.6001 16.8358V4.7999C5.6001 3.51582 6.60854 2.46727 7.87666 2.40303L8.0001 2.3999H20.1376L20.2954 2.40771C20.6617 2.44407 21.0063 2.60608 21.2688 2.86865L25.9313 7.53115C26.2313 7.83115 26.4 8.23814 26.4001 8.6624V17.2124L26.3892 17.3968C26.3396 17.8233 26.1203 18.2154 25.7759 18.4804L17.0001 25.2312L16.8876 25.3101C16.3507 25.6545 15.6584 25.6459 15.1298 25.289L15.0188 25.2077L6.19463 18.0804C5.86561 17.8146 5.65728 17.431 5.61025 17.0155L5.6001 16.8358ZM6.4001 16.8358C6.4002 17.0774 6.5098 17.3059 6.69775 17.4577L15.522 24.5851C15.8097 24.8172 16.2187 24.8221 16.5118 24.5968L25.2876 17.846L25.3579 17.7858C25.5118 17.6362 25.6 17.4296 25.6001 17.2124V8.6624C25.6 8.47675 25.5355 8.2977 25.4188 8.15537L25.3657 8.09678L20.7032 3.43428C20.5532 3.2843 20.3497 3.19997 20.1376 3.1999H8.0001C7.11644 3.1999 6.4001 3.91625 6.4001 4.7999V16.8358Z"
        fill="url(#paint3_linear_1609_7317)"
      />
      <path
        d="M1.68437 14.1546C1.80314 14.0019 2.0105 13.9586 2.17734 14.0413L2.24531 14.0843L16.3922 25.0874L29.7461 14.0913C29.9166 13.951 30.1682 13.9755 30.3086 14.146C30.4489 14.3166 30.4244 14.5681 30.2539 14.7085L16.6539 25.9085L16.407 26.1124L16.1547 25.9156L1.75469 14.7156L1.69609 14.6601C1.57487 14.5188 1.56569 14.3073 1.68437 14.1546Z"
        fill="url(#paint4_linear_1609_7317)"
      />
      <path
        d="M15.063 19.8766C15.6222 19.4728 16.3773 19.4728 16.9366 19.8766L29.3969 28.8758C29.7115 29.103 29.5508 29.6001 29.1627 29.6001H2.8368C2.44873 29.6001 2.28801 29.103 2.6026 28.8758L15.063 19.8766Z"
        fill="url(#paint5_linear_1609_7317)"
      />
      <path
        d="M15.0634 19.8766C15.6226 19.4728 16.3776 19.4728 16.9368 19.8766L29.3969 28.8758C29.6919 29.0889 29.5693 29.5393 29.2329 29.5946L29.1634 29.6H2.83679L2.76726 29.5946C2.43083 29.5393 2.3082 29.0889 2.6032 28.8758L15.0634 19.8766ZM16.4688 20.525C16.2242 20.3484 15.9041 20.3262 15.6407 20.4586L15.5313 20.525L4.07429 28.8H27.9259L16.4688 20.525Z"
        fill="url(#paint6_linear_1609_7317)"
      />
      <path
        d="M16.2198 10.2711L15.999 10.4993L15.7783 10.2701C14.9185 9.38023 13.5199 9.37627 12.6562 10.2622L12.6485 10.2701C11.7838 11.164 11.7838 12.6095 12.6485 13.5044L15.6424 16.6463C15.8361 16.8487 16.1523 16.8517 16.3499 16.6532L16.3566 16.6463L19.3515 13.5044C20.2162 12.6105 20.2162 11.165 19.3515 10.2701C18.4917 9.38023 17.0931 9.37627 16.2294 10.2612L16.2198 10.2711Z"
        fill="rgb(var(--oui-color-primary-light))"
      />
      <path
        d="M15.9992 9.92654C17.0243 8.93604 18.641 8.95922 19.6391 9.99217L19.7312 10.0922C20.6519 11.146 20.6216 12.7633 19.6406 13.7797L19.6414 13.7804L16.6461 16.9219L16.6437 16.925L16.6336 16.9351C16.2776 17.2926 15.7023 17.2874 15.3531 16.9226V16.9219L12.3586 13.7804V13.7797C11.3466 12.7297 11.3471 11.0404 12.3609 9.99217L12.3695 9.98357V9.98279L12.4672 9.88748C13.4713 8.95732 15.0109 8.97251 15.9992 9.92654ZM19.0641 10.5476C18.3608 9.81979 17.2216 9.81726 16.5156 10.5406L16.507 10.55L16.5062 10.5492L16.2867 10.7773L15.9984 11.075L15.7109 10.7765L15.4898 10.5476V10.5469C14.7865 9.81999 13.6486 9.81767 12.943 10.5414L12.9422 10.5406L12.9351 10.5476L12.9359 10.5484C12.2663 11.2409 12.2241 12.3379 12.8101 13.082L12.9359 13.2265L12.9383 13.2281L15.9312 16.3695L15.9633 16.3922C15.9974 16.4073 16.0371 16.4004 16.0664 16.3711L16.0695 16.3672L19.0617 13.2281L19.0641 13.2258L19.1898 13.0828C19.7369 12.3893 19.7369 11.3867 19.1898 10.6922L19.0641 10.5476Z"
        fill="rgb(var(--oui-color-primary-light))"
      />
      <path
        d="M20 7.19997V3.53134C20 2.81862 20.8617 2.46168 21.3657 2.96565L25.8343 7.43428C26.3383 7.93826 25.9814 8.79997 25.2686 8.79997H21.6C20.7163 8.79997 20 8.08363 20 7.19997Z"
        fill="rgb(var(--oui-color-primary-darken))"
      />
      <path
        d="M20 7.19997V3.53122C20.0001 2.8186 20.8617 2.46174 21.3656 2.9656L25.8344 7.43435C26.3068 7.90689 26.0224 8.69348 25.3977 8.78981L25.2688 8.79997V7.99997L20.8 3.53122V7.19997C20.8 7.6418 21.1582 7.99997 21.6 7.99997V8.79997C20.7163 8.79997 20 8.08363 20 7.19997ZM25.2688 7.99997V8.79997H21.6V7.99997H25.2688Z"
        fill="url(#paint7_linear_1609_7317)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1609_7317"
          x1="2.8001"
          y1="15.5451"
          x2="29.6001"
          y2="15.5451"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-4))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-8))" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1609_7317"
          x1="16.0001"
          y1="3.99998"
          x2="16.0001"
          y2="29.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-2))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-7))" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1609_7317"
          x1="25.6001"
          y1="14.3999"
          x2="9.46705"
          y2="7.84048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-gradient-primary-end))" />
          <stop offset="1" stopColor="rgb(var(--oui-gradient-primary-start))" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1609_7317"
          x1="15.2001"
          y1="25.9999"
          x2="23.4343"
          y2="5.74778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-gradient-primary-end))" />
          <stop offset="1" stopColor="rgb(var(--oui-gradient-primary-start))" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1609_7317"
          x1="30"
          y1="14.3999"
          x2="2"
          y2="14.3999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-3))" />
          <stop offset="0.483985" stopColor="rgb(var(--oui-color-base-1))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-3))" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1609_7317"
          x1="1.59977"
          y1="24.4001"
          x2="30.3998"
          y2="24.4001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-4))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-8))" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1609_7317"
          x1="16.0001"
          y1="19.2"
          x2="16.0001"
          y2="29.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-base-1))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-base-7))" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1609_7317"
          x1="23.6"
          y1="5.19997"
          x2="20"
          y2="8.79997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-color-primary))" />
          <stop offset="1" stopColor="rgb(var(--oui-color-primary-darken))" />
        </linearGradient>
      </defs>
    </svg>
  );
};
